<template>
    <p :class="['field', { invalid: isInvalid }]">
        <label v-if="required" :for="id">
            <slot></slot>
            *<span v-if="helpText"> ({{ helpText }})</span>
        </label>
        <label v-else :for="id">
            <slot></slot>
          <span v-if="helpText"> ({{ helpText }})</span>
        </label>
        <textarea
                :id="id"
                :name="id"
                :rows="rows"
                :cols="cols"
                :value="value"
                @input="emitChange($event.target.value)"
                @focus="emitFocus"
                @blur="emitBlur(true)"
                :disabled="disabled"
                ref="textarearef"
        ></textarea>
    </p>
</template>

<script>
	export default {
		name: "TextareaInput",
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			id: String,
			value: [String, Number],
			rows: [String, Number],
			cols: [String, Number],
			disabled: Boolean,
			required: {
				type: Boolean,
				default: false
			},
      helpText: {
        type: String,
        default: ''
      },
		},
		data() {
			return {
				touched: false,
				forcedInvalid: false,
			}
		},
		computed: {
			isInvalid() {
				return (this.touched && this.required && !this.value) || this.isForcedInvalid
			},
			isForcedInvalid() {
				return this.forcedInvalid
			}
		},
		methods: {
			emitChange(value) {
				this.$emit('change', value)
				this.setTouched(true)
			},
			emitFocus() {
				this.$emit('focus', true)
			},
			setTouched(value) {
				this.touched = value
			},
			emitBlur(value) {
				this.setTouched(value)
				this.$emit('blur', value)
			},
			setForcedInvalid(value) {
				this.forcedInvalid = value
			},
      getCursorPosition(){
        return this.$refs.textarearef.selectionStart;
      },
      setCursorPosition(position){
        this.$refs.textarearef.setSelectionRange(position, position);
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/TextareaInput.vue